import script from "./NotificationBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBlock.vue?vue&type=script&setup=true&lang=js"

import "./NotificationBlock.vue?vue&type=style&index=0&id=d38ce218&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d38ce218"]])

export default __exports__